// import { GlobalErrorActions } from "@redux/globalError/GlobalErrorSlice";
import axios, { AxiosRequestConfig } from "axios";
// import { CUSTOM_HEADERS, DISPLAY_MESSAGES } from "./../constants";
// import { logout } from "./../redux/UserSlice";
// import { validateRefreshToken } from "./api";
// import { getCurrentSiteData } from "./asyncStore.service";
import { store as reduxStore } from './store';
// import { CUSTOM_HEADERS } from "@parent-app/config";
// import { getRequestSignature } from "../utilities/helpers";
// import RNConfig from 'react-native-config';
import { ChildrenStoreData, EymemoryLoginStorageData, LoginStorageData, RootState, WebInfoStateType } from '../../shared/types/src/index';
import { CUSTOM_HEADERS } from "../../shared/config/src/index";
import { getRequestSignature } from "../utilities/helpers";
import { logout, validateLoginTokens } from "src/shared/redux-state/src";
import { unwrapResult } from "@reduxjs/toolkit";
import { API_URL } from "../config/appConstants";

// define the type of retry queue
interface RetryQueueItem {
    resolve: (value?: any) => void;
    reject: (error?: any) => void;
    config: AxiosRequestConfig;
}

const PART_URL = "/index.php/rest/staff-app/"
const refreshAndRetryQueue: RetryQueueItem[] = [];
let isRefreshing = false;

// common headers required by every request
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

const noRetryAxios = axios.create({});  // instance used for request which do not need to be retried on 401
const retryAxios = axios.create({});  // instance used for all requests which will be retried
const eymemoriesAxios = axios.create({}); // instance used for handling eymemories orders.

noRetryAxios.interceptors.request.use(
    async (config: any) => {
        config = addCustomHeaders(config);
        const loginState: LoginStorageData = (reduxStore.getState() as RootState).persistLogin.loginData;
        console.log("running from web baseURL : ", API_URL);
        config.url = `${API_URL}${config.url}`;
        if (loginState && loginState.accessToken) {
            config.headers['Authorization'] = `Bearer ${loginState.accessToken}`;
        }
        if (config.data && Object.keys(config.data).length) {
            const { signature, timestamp } = await getRequestSignature(config.data);
            config.headers[CUSTOM_HEADERS.PAYLOAD_SIGNATURE] = signature;
            config.headers[CUSTOM_HEADERS.PAYLOAD_TIMESTAMP] = timestamp;
        }
        return config;
    },
    error => Promise.reject(error)
);

eymemoriesAxios.interceptors.request.use(
    async (config: any) => {
        config = addCustomHeaders(config);
        const eymemoryPersistLoginState = (reduxStore.getState() as RootState)?.eymemoryPersistLogin;
        config.url = `${API_URL}${config.url}`;
        if (config?.headers?.orderHash && eymemoryPersistLoginState
             && eymemoryPersistLoginState?.[config?.headers?.orderHash]?.loginData ) {
            config.headers['Authorization'] = `Bearer ${eymemoryPersistLoginState[config?.headers?.orderHash as string]?.loginData?.accessToken}`;
            delete config.headers.orderHash;
        }
        if (config.data && Object.keys(config.data).length) {
            const { signature, timestamp } = await getRequestSignature(config.data);
            config.headers[CUSTOM_HEADERS.PAYLOAD_SIGNATURE] = signature;
            config.headers[CUSTOM_HEADERS.PAYLOAD_TIMESTAMP] = timestamp;
        }
        return config;
    },
    error => Promise.reject(error)
);

retryAxios.interceptors.request.use(
    async (config: any) => {
        config = addCustomHeaders(config);
        const loginState: LoginStorageData = (reduxStore.getState() as RootState).persistLogin.loginData;
        const currentChild: ChildrenStoreData = (reduxStore.getState() as RootState).persistLogin.currentChild;
        console.log("running from web baseURL : ", API_URL);
        // config = { ...config, url: `${API_URL}${config.url}` };


        if (!config?.url?.startsWith('https') && !config.url?.startsWith('http')) {
            config.url = `${API_URL}${config.url}`
        }

        // add instance token by default
        if (currentChild && currentChild.instanceToken) {
            config.headers['Authorization'] = `Bearer ${currentChild.instanceToken}`
        }

        // override with access token if some api requires access token
        if (config.params && Object.keys(config.params).length > 0) {
            const { useAccessToken } = config.params;
            if (useAccessToken) {
                config.headers['Authorization'] = `Bearer ${loginState.accessToken}`;
            }
        }

        if (config.data && Object.keys(config.data).length) {
            const { signature, timestamp } = await getRequestSignature(config.data);
            config.headers[CUSTOM_HEADERS.PAYLOAD_SIGNATURE] = signature;
            config.headers[CUSTOM_HEADERS.PAYLOAD_TIMESTAMP] = timestamp;
        }
        return config;
    },
    error => {
        Promise.reject(error)
    }
);

noRetryAxios.interceptors.response.use(
    async (response) => {
        // console.log("response from api in axios : ", response);
        try {
            // validate if the response is HTML or valid JSON
            const contentType: any = response.headers['content-type'];
            if (contentType.includes('application/json'))
                return response;
            else if (response.config.url?.endsWith("/eyMan") || response.config.url?.endsWith("/eyMan/")) {
                return response;
            } else throw new Error(`This site is not valid`);
        } catch (error: any) {
            // await store.dispatch(GlobalErrorActions.setError({ isError: true, message: error.message }));
            // await store.dispatch(logout());
            return Promise.reject(error);
        }
    },
    async (error) => {
        console.log("error from api in noretry interceptor : ", error);
        if (error.response && error.response.status >= 500) {
            // await store.dispatch(GlobalErrorActions.setError({ isError: true, message: DISPLAY_MESSAGES.SERVER_ERROR }));
        } else if (error.response && error.response.status === 401) {
            if (error.config.url.endsWith("login")) {
                throw error;
            } else {
                // await store.dispatch(logout());
                throw error;
            }
        } else if ((error.config.url.endsWith("/eyMan") || error.config.url.endsWith("/eyMan/") || error.config.url.endsWith("/login")) && error.response && error.response.status == 404) {
            // this is the case when user enters wrong site url
            throw error;
        } else if (error.response && error.response.status >= 400) {
            // await store.dispatch(GlobalErrorActions.setError({ isError: true, message: DISPLAY_MESSAGES.INVALID_REQUEST }));
            throw error;
        } else throw error;
    }
);

eymemoriesAxios.interceptors.response.use(
    async (response) => {
        // console.log("response from api in axios : ", response);
        try {
            // validate if the response is HTML or valid JSON
            const contentType: any = response.headers['content-type'];
            if (contentType.includes('application/json'))
                return response;
            else if (response.config.url?.endsWith("/eyMan") || response.config.url?.endsWith("/eyMan/")) {
                return response;
            } else throw new Error(`This site is not valid`);
        } catch (error: any) {
            return Promise.reject(error);
        }
    },
    async (error) => {
        console.log("error from api in noretry interceptor : ", error);
        throw error;
    }
);

// retry failed requests due to 401 error
retryAxios.interceptors.response.use(
    async (response) => {
        try {
            // console.log("response from api in axios : ", response);
            // validate if the response is HTML or valid JSON
            const contentType: any = response.headers['content-type'];
            if (contentType.includes('application/json'))
                return response;
            else throw new Error(`This site is not valid`);
        } catch (error: any) {
            //    await store.dispatch(GlobalErrorActions.setError({ isError: true, message: '' }));
            //    await store.dispatch(logout());
            return Promise.reject(error);
        }
    },
    async (error) => {
        console.log("error from api in retry interceptor : ", error, error.response.data);
        // const dispatch = useAppDispatch();
        const originalRequest: AxiosRequestConfig = error.config;
        if (error.response && error.response.status >= 500) {
            // await store.dispatch(GlobalErrorActions.setError({ isError: true, message: DISPLAY_MESSAGES.SERVER_ERROR }));
        } else if (error.response && error.response.status === 401) {
            console.log("hiting refresh call");
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    // Refresh the access token
                    await reduxStore.dispatch(validateLoginTokens({ reduxStore }))
                        .then(unwrapResult)
                        .then(async (result) => {
                            console.log("result from validation : ", result);
                            if (!result) {
                                await reduxStore.dispatch(logout({ reduxStore }));
                            }
                        });
                    const loginState: LoginStorageData = (reduxStore.getState() as RootState).persistLogin.loginData;
                    // Update the request headers with the new access token
                    error.config.headers['Authorization'] = `Bearer ${loginState?.accessToken}`;

                    // Retry all requests in the queue with the new token
                    refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
                        retryAxios
                            .request(config)
                            .then((response) => resolve(response))
                            .catch((err) => reject(err));
                    });

                    // Clear the queue
                    refreshAndRetryQueue.length = 0;

                    // Retry the original request
                    return retryAxios(originalRequest);
                } catch (refreshError) {
                    // Handle token refresh error
                    // You can clear all storage and redirect the user to the login page
                    // throw refreshError;
                    await reduxStore.dispatch(logout({ reduxStore }));
                } finally {
                    isRefreshing = false;
                }
            }

            // Add the original request to the queue
            return new Promise<void>((resolve, reject) => {
                refreshAndRetryQueue.push({ config: originalRequest, resolve, reject });
            });
        } else if (error.response && error.response.status >= 400) {
            throw error;
        }

        // Return a Promise rejection if the status code is not 401
        return Promise.reject(error);
    }
);


const getBaseUrl = async (): Promise<{ siteUrl: string, accessToken: string | undefined }> => {
    // const siteData = store.getState();
    // return { siteUrl: siteData!.site, accessToken: siteData!.accessToken };
    return { siteUrl: '', accessToken: '' };
}

// const verifyRefreshToken = async () => {
//     const siteData = store.getState().site.currentSite;
//     if (!siteData) {
//         await store.dispatch(logout());
//     } else {
//         const params = {
//             url: `${siteData.site}/index.php/rest/staff-app/auth`,
//             accessToken: siteData.accessToken || '',
//             refreshToken: siteData.refreshToken || ''
//         }
//         let validity = await validateRefreshToken(params);
//         if (!validity) {
//             await store.dispatch(logout());
//         }
//     }
// }

const addCustomHeaders = (config: any) => {
    const { appInfo } = reduxStore.getState();
    // console.log("appInfo in axios of mobile app : ", appInfo);
    if (Object.keys(appInfo).length) {
        const { uniqueDeviceId } = appInfo as WebInfoStateType;
        // config.headers[CUSTOM_HEADERS.APP_VERSION] = appVersion;
        // config.headers[CUSTOM_HEADERS.OS_VERSION] = osVersion;
        // config.headers[CUSTOM_HEADERS.PLATFORM] = platform;
        // config.headers['User-Agent'] = `${bundleId}/${platform}/${appVersion}(${appBuildNo})/${brand}/${manufacturer}/${deviceName}/${osVersion}`;
        config.headers[CUSTOM_HEADERS.UNIQUE_DEVICE_ID] = uniqueDeviceId;
    }
    return config;
}

export { noRetryAxios, retryAxios, eymemoriesAxios };
